import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.home');
import { OnInit } from '@angular/core';

@Component({
    selector: 'wiz-page-home',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.home/view.scss */
/* src/app/page.home/view.scss: no such file or directory */`],
})
export class PageHomeComponent implements OnInit {
    constructor() { }
    public async ngOnInit() {
        location.href = '/prototype5';
    }
}

export default PageHomeComponent;